<template>
  <div id="user-list">
    <div class="cards row row-cards">
      <template v-if="isNotFound(items) && !busy">
        <span class="items-not-found">Ничего не найдено</span>
      </template>
      <template v-else>
        <div class="col-md-6 col-lg-3" v-for="item in items" :key="row.getId(item)" :class="{'no-active': !row.getActive(item)}">
          <div class="card">
            <div class="card-body p-4 text-center">
              <span class="avatar avatar-xl mb-3 rounded-circle" :style="{ backgroundImage: 'url(' + row.getImage(item, 150) + ')' }"></span>
              <h3 class="m-0 mb-2">
                <span>
                  <a href="#" v-text="row.getName(item)"></a>
                </span>
              </h3>
              <div class="text-secondary mb-2">ID: {{ row.getId(item) }}</div>
              <div class="mb-2">
                <span class="badge bg-purple-lt" v-text="row.getRole(item)"></span>
              </div>
            </div>
            <div class="d-flex">
              <a href="#" class="card-btn" data-bs-toggle="modal" data-bs-target="#modal-user" data-type="update" :data-id="row.getId(item)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon me-2 text-muted icon-tabler icon-tabler-edit" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                  <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                  <path d="M16 5l3 3" />
                </svg>
                Редактировать
              </a>
            </div>
          </div>
        </div>
      </template>
      <div class="loader-posts">
        <div class="spinner-border" v-show="busy"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, ref, watch} from "vue"
import element from "@/modules/users/pages/users/components/list/services/element"
import UserImage from "@/modules/users/services/UserImage"
import Helper from "@/services/Helper"
import Api from "@/modules/users/pages/users/components/list/services/Api"

export default defineComponent({
  name: "List",
  components: {},
  props: {
    query: {
      type: Object,
      required: true
    },
    clearResult: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {emit}) {
    let busy = ref(false)
    let items = ref([])
    let eofItems = ref(false)
    let countItems = ref(0)

    let row = {
      getId: (item) => {
        return element.getId(item)
      },
      getImage: (item, w) => {
        let avatarHost = element.getAvatarHost(item)
        let avatarName = element.getAvatarName(item)

        if (avatarHost !== null && avatarName !== null) {
          return getImage(avatarHost, avatarName, w)
        } else {
          return getImage(null, null, w)
        }
      },
      getActive: (item) => {
        return element.getActive(item)
      },
      getName: (item) => {
        return element.getName(item)
      },
      getRole: (item) => {
        return element.getRole(item)
      },
    }

    function isNotFound(items) {
      return Helper.isEmptyObject(items)
    }

    function getImage(host, name, w = null, h = null) {
      return UserImage.handle(host, name, w, h)
    }

    watch(() => props.query, (query) => {
      busy.value = true

      if (props.clearResult) {
        clearResult()
      }

      load(query)
    })

    function clearResult() {
      eofItems.value = false
      countItems.value = 0
      items.value = []
    }

    function load(query, offset = null) {
      if (offset !== null) {
        query.offset = offset;
      }

      Api.users(query).then((resp) => {
        let item = resp.item

        items.value.push(...item)

        if (item.length === 0) {
          eofItems.value = true
        }

        countItems.value = resp.param.cnt
      }).finally(() => {
        busy.value = false

        emit("onRender", {
          "oef_items": eofItems.value,
          "count_items": countItems.value
        })
      })
    }

    return {
      busy,
      items,
      row,
      isNotFound,
    }
  }
})
</script>
